import React, { useState, useEffect, useRef } from 'react';
import { Link,  useNavigate } from 'react-router-dom';
import '../../styles/Header.css';
import { Button } from 'react-bootstrap';
import { FaUser, FaDollarSign, FaHome, FaHistory, FaBars } from "react-icons/fa";
import instance from '../../services/endpoint';
// import img from '../Sign&Regs/image.png';
import img from '../../images/Bitstek-Advisory.jpg';
import { GoGraph } from 'react-icons/go';
import { toast } from 'react-toastify';
import Loader from "../utilComponents/loader.js";

const Header = ({ page }) => {
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
    const [darkMode, setDarkMode] = useState(true);
    const [showDropdown, setShowDropdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const [userData, setUserData] = useState({
        FullName: "",
        AccountID: "",
        amount: "",
    });

    const fetchUserData = async () => {
        try {
            const response = await instance.get("/api/v1/auth/profile");
            setUserData({
                FullName: response.data.FullName,
                AccountID: response.data.AccountID,
                amount: response.data.amount,
            });
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    const handleLogout = async () => {
        setLoading(true);
        try {
            await instance.post("/api/v1/auth/logout");
            toast.success("Logout successful");
            navigate("/login");
        } catch (error) {
            console.error("Error during logout:", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // Handle click outside dropdown to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    return (
        <>
            {loading && <Loader />}
            <header className={`header ${darkMode ? 'dark' : 'light'}`}>
                <div className="header-content">
                    <div className="logo" title="Bitstek Advisory">
                        <Link to={"/dashboard"}>
                        <img
                            src={img}
                            width={100}
                            alt="Bitstek Advisory"
                            className="logo-image"
                        />
                        </Link>
                    </div>
                    <div className='Head-name'>
                        <span className="logo-text">Bitstek Advisory</span>
                    </div>
                    <div className="actions">
                        {page === 'register' || page === 'login' ? (
                            <div className="time">{currentTime}</div>
                        ) : page === 'dashboard' ? (
                            <div className="profile-menu" ref={dropdownRef}>
                                <button
                                    className="profile-button"
                                    onClick={() => setShowDropdown(!showDropdown)}
                                >
                                    <FaBars />
                                </button>
                                {showDropdown && (
                                    <div className="dropdown">
                                        <div className="text-center dropdown-main">
                                            <img
                                                src={img}
                                                alt="Bitstek Advisory Logo"
                                            />
                                            <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>
                                                Hi, {userData.FullName}
                                            </h5>
                                            <div className="align-items-center text-center">
                                                <div className="mb-2 d-flex justify-content-center align-items-center">
                                                    <strong className="me-2">Account ID:</strong>
                                                    <p className="mb-0">{userData.AccountID}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-wrap justify-content-center mb-3">
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/dashboard")}
                                            >
                                                <FaHome size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>Dashboard</p>
                                            </div>
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/tradingwidget")}
                                            >
                                                <GoGraph size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>Graph</p>
                                            </div>
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/history")}
                                            >
                                                <FaHistory size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>History</p>
                                            </div>
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/bank")}
                                            >
                                                <FaDollarSign size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>Funds</p>
                                            </div>
                                            <div
                                                className="text-center header-icon"
                                                style={{ margin: "10px", cursor: "pointer" }}
                                                onClick={() => navigate("/profile")}
                                            >
                                                <FaUser size={22} color="#e2c25e" />
                                                <p style={{ fontSize: "10px", marginTop: "5px" }}>Settings</p>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                style={{ fontSize: "13px" }}
                                                onClick={handleLogout}
                                            >
                                                Logout
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
